import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import url_tool from 'url'


Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,

    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            redirect: {
                name: 'CrowdFunding'
            },
            children: [
                {
                    path: 'crowdfunding',
                    name: 'CrowdFunding',
                    component: () => import('./views/crowdfunding/home.vue')
                },
                {
                    path: 'detail',
                    name: 'CrowdFundingDetail',
                    component: () => import('./views/crowdfunding/detail.vue')
                }
        ]
    },
        {
            path: '/user',
            name: 'User',
            component: () => import('./views/user/index.vue'),
            //            redirect: {
            //                name: 'UserCenter'
            //            },

    },
        {
            path: '/address',
            name: 'Address',
            component: () => import('./views/user/address.vue'),
        },
        {
            path: '/add-address',
            name: 'AddAddress',
            component: () => import('./views/user/addAddress.vue'),
        },
        {
            path: '/user-orders',
            name: 'UserOrders',
            meta:{
                title:"我的订单"
            },
            component: () => import('./views/user/orders.vue'),
        },

  ]
})

router.beforeEach(async (to, from, next) => {
    let next_url = to.fullPath

    let params = to.query


    if (to.query['code']) {
        let code = to.query.code
        let state = to.query.state
        let uri = location.href

        Vue.http.post('/v1/get_user_open_id', {
            code: code,
            state: state
        }).then(function (re) {
            localStorage.setItem('mall_token', re.data.token)
            delete params.code
            delete params.state
            next_url = to.path + url_tool.format({
                query: params
            })
            next(next_url)
        })

    } else if (to.query['token']) {
        let token = to.query['token']
        localStorage.setItem('mall_token', token)
        delete params.token
        next_url = to.path + url_tool.format({
            query: params
        })
        //        console.log(next_url)
        next(next_url)
    } else {
        next()
    }
})

export default router
